export default "__VITE_ASSET__6c8bd109__"